import request from './request'

export function recordVisit(data) {
  return request({
    url: '/front/visits',
    method: 'post',
    data
  })
}

export function getVisitStats() {
  return request({
    url: '/admin/visits/stats',
    method: 'get'
  })
}

export function getVisitList(params) {
  return request({
    url: '/admin/visits',
    method: 'get',
    params
  })
}